import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-hari-kiran',
  templateUrl: './hari-kiran.component.html',
  styleUrls: ['./hari-kiran.component.scss']
})
export class HariKiranComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getHari();
  }

}
